import { CommonActions } from '@crossiety/design';
import { reloadElement } from 'src/utils';
import { on } from 'src/lib/utils';

// navbar - unread web notifications count badge
const lastCounts = {
  web_notifications: 0,
};

let pageTitle;

function updateDropdown() {
  document.querySelector('xs-notification-top-dropdown')?.load();
}

function updateIndexPageNotifications() {
  const unreadNotifications = document.querySelectorAll('.js-notifications xs-notification:not([isRead]');
  lastCounts.web_notifications = 0;
  unreadNotifications.forEach(item => item.isRead = true);
}

function updateDocumentTitle() {
  const chatNotificationCount = window.computedChatsStore?.value?.unreadCounters?.allWithoutMuted;
  const totalCount = chatNotificationCount + lastCounts.web_notifications;

  if (App.notifications_count !== totalCount) {
    App.notifications_count = totalCount;

    document.dispatchEvent(
      new CustomEvent('notifications:total_count:update', {
        bubbles: false,
        cancelable: true,
        detail: {
          totalCount,
        },
      }),
    );

    document.title = App.notifications_count > 0 ? (`(${App.notifications_count}) ${pageTitle}`) : pageTitle;
  }
}

$(document)
  .on('turbolinks:load', () => {
    pageTitle = document.title.replace(/\(\d+\)\s*/, '');
  })

  .on('sync', (e) => {
    const data = e.detail;
    if (data.unread_web_notifications_count !== lastCounts.web_notifications) {
      updateDropdown();
      reloadElement('.js-notifications');
    }

    lastCounts.web_notifications = data.unread_web_notifications_count;

    updateDocumentTitle();
  })

  .on('visibility', () => {
    updateDocumentTitle();
  })

  .on('message-global-received', () => {
    updateDocumentTitle();
  });

on(document, 'click', '.js-read-all-web-notifications', async (e) => {
  const commonActions = new CommonActions(e);

  try {
    await commonActions.post(e.dataset.url);
    updateIndexPageNotifications();
    updateDropdown();
  } catch {
    commonActions.displaySnackBarError();
  }
});

on(document, 'notificationTopDropdown-markAllAsRead', 'xs-notification-top-dropdown', updateIndexPageNotifications);
